/* ALGEA lens treatments — ratings, descriptions and warranties shown inside each lens option.

   Internal source (never shown to customers; owner 2026-09-28 asked for no catalogue references in
   the storefront recommender): ALGEA Optika_Katalogu i lenteve 2026.pdf (FINAL, 2026-09-24,
   sha256 fd025ced…) — p.03 Ital Lenti ratings, p.04 Essilor Crizal ratings + "best for" lines and
   World Vision included features, p.16 drivers, p.18 Mirror UV, p.23 kids treatments, p.29–30
   warranties; Ital Lenti Listino (UVTech wording).

   Each brand rates on its own scale (Ital Lenti prints six stars for IRON+; Essilor up to five), so
   ratings are only compared within a brand. World Vision is described by included features, never
   stars. A treatment without printed ratings shows its description only — nothing is invented. */
window.ALGEA_STARS = {
  maxByBrand: { "Ital Lenti": 6, "Essilor": 5 },

  dims: {
    ar: "Antireflektim",
    scratch: "Rezistencë ndaj gërvishtjeve",
    water: "Uji rrëshqet",
    smudge: "Anti-njollë",
    static: "Pluhuri (antistatik)",
    impact: "Rezistencë ndaj goditjeve",
    blue: "Mbrojtje nga drita blu"
  },

  lines: {
    "Ital Lenti": {
      rows: {
        "HMC+":     { ar: 4, scratch: 4, water: 3, smudge: 3, static: null, impact: 3, blue: null },
        "ICE":      { ar: 5, scratch: 5, water: 5, smudge: 5, static: 5,    impact: 4, blue: null },
        "BLUBLOCK": { ar: 5, scratch: 5, water: 5, smudge: 5, static: 5,    impact: 5, blue: 5 },
        "IRON":     { ar: 5, scratch: 5, water: 5, smudge: 5, static: 5,    impact: 5, blue: null },
        "IRON+":    { ar: 6, scratch: 6, water: 6, smudge: 6, static: 6,    impact: 6, blue: null }
      },
      about: {
        "BLUBLOCK": "Mbrojtja kryesore nga drita blu e ekraneve.",
        "IRON": "Rezistencë dhe qartësi premium.",
        "IRON+": "Rezistencë dhe qartësi premium — niveli më i lartë i Ital Lenti.",
        "UVTECH": "Material që filtron 99% të rrezeve UV dhe 55% të dritës blu.",
        "DURAKIDS": "Trajtim fortësues për fëmijë — mbron xhamin nga gërvishtjet, por nuk heq reflekset.",
        "IRON KIDS": "Versioni për fëmijë i IRON: fortësim, antireflektim, hidrorepelencë dhe antistatik.",
        "EASYDRIVE": "Trajtim anti-shkëlqim për drejtim mjeti — kontrast më i mirë natën.",
        "HARD": "Trajtim fortësues kundër gërvishtjeve.",
        "BIANCHE": "Lente pa trajtim.",
        "PA TRAJTIM": "Lente pa trajtim."
      }
    },
    "Essilor": {
      rows: {
        "CRIZAL ROCK":         { ar: 5, scratch: 5, water: 5, smudge: 5, static: 5, blue: null },
        "CRIZAL NATURAL":      { ar: 5, scratch: 5, water: 5, smudge: 5, static: 5, blue: null },
        "CRIZAL PREVENCIA":    { ar: 5, scratch: 4, water: 5, smudge: 5, static: 5, blue: 5 },
        "CRIZAL SUN XPROTECT": { ar: 5, scratch: 4, water: 5, smudge: 5, static: 5, blue: null },
        "CRIZAL KIDS":         { ar: 4, scratch: 5, water: 4, smudge: 4, static: 4, blue: 4 }
      },
      espf: { "CRIZAL ROCK": "35", "CRIZAL NATURAL": "35", "CRIZAL PREVENCIA": "35", "CRIZAL SUN XPROTECT": "50+", "CRIZAL KIDS": "35" },
      about: {
        "CRIZAL ROCK": "Rezistencë maksimale ndaj gërvishtjeve.",
        "CRIZAL NATURAL": "Qartësi maksimale — trajtimi standard premium i Essilor.",
        "CRIZAL PREVENCIA": "Mbrojtje nga drita blu — për ekrane.",
        "CRIZAL SUN XPROTECT": "Për xhama dielli dhe të polarizuar.",
        "CRIZAL KIDS": "Për fëmijë — rezistencë dhe higjienë.",
        "CRIZAL KIDS UV": "Për fëmijë — rezistencë dhe higjienë.",
        "MIRROR UV": "Efekt pasqyre — estetikë premium për diell intensiv.",
        "STREETLIFE": "Për drejtim mjeti ditë e natë — redukton shkëlqimin verbues."
      }
    }
  },

  worldVision: {
    features: ["Anti-refleks", "Shtresë e lehtë kundra gërvishtjeve dhe pluhurit", "Filtër drite blu për ekrane", "Optimizuar për drejtim mjeti"],
    rows: {
      "UC (PA TRAJTIM)": [false, false, false, false],
      "HMC":             [true,  true,  false, false],
      "BLUE PROTECT":    [true,  true,  true,  false],
      "DRIVERS":         [true,  true,  true,  true]
    },
    about: {
      "UC (PA TRAJTIM)": "Buxhet minimal, për receta të thjeshta.",
      "HMC": "Anti-refleks bazë — vlera më e mirë çmim/cilësi.",
      "BLUE PROTECT": "Filtër drite blu për ekrane, me kosto të ulët.",
      "DRIVERS": "Optimizuar për drejtim mjeti, me çmim ekonomik."
    }
  }
};

window.ALGEA_STARS.key = function (lens) {
  return String(lens && lens.treatment || "").toUpperCase().trim();
};

/* Ratings for one lens: { kind: "stars", max, rows:[{key,label,score}], espf } | { kind: "included", features } | null */
window.ALGEA_STARS.forLens = function (lens) {
  var S = window.ALGEA_STARS;
  if (!lens) return null;
  var key = S.key(lens);
  if (lens.brand === "World Vision") {
    var inc = S.worldVision.rows[key];
    if (!inc) return null;
    return { kind: "included", features: S.worldVision.features.filter(function (_, i) { return inc[i]; }) };
  }
  var table = S.lines[lens.brand];
  var row = table && table.rows[key];
  if (!row) return null;
  var order = ["ar", "scratch", "blue", "impact", "water", "smudge", "static"];
  var rows = [];
  order.forEach(function (d) { if (row[d] != null) rows.push({ key: d, label: S.dims[d], score: row[d] }); });
  return { kind: "stars", max: S.maxByBrand[lens.brand], rows: rows, espf: table.espf ? table.espf[key] || null : null };
};

/* One-line description of what the treatment is best for (FINAL wording), or "". */
window.ALGEA_STARS.about = function (lens) {
  var S = window.ALGEA_STARS;
  if (!lens) return "";
  var key = S.key(lens);
  if (lens.brand === "World Vision") return S.worldVision.about[key] || "";
  var table = S.lines[lens.brand];
  return table && table.about[key] || "";
};

/* W34: translate the display text once at load (keys and data stay Albanian). */
(function () {
  var S = window.ALGEA_STARS;
  var T = function (s) { return window.AlgeaT ? window.AlgeaT(s) : s; };
  function map(o) { Object.keys(o).forEach(function (k) { if (typeof o[k] === "string") o[k] = T(o[k]); }); }
  map(S.dims);
  Object.keys(S.lines).forEach(function (b) { map(S.lines[b].about); });
  S.worldVision.features = S.worldVision.features.map(T);
  map(S.worldVision.about);
})();
